import React from "react";
import { Route, Routes } from "react-router-dom";
import UserProfile from "./Components/UserProfile/UserProfile";
import AIToolsPre from "./Components/AITools/AIToolsPre";
//import UserExperiment from "./Components/Experiments/UserExperiment";
//import AdminProfile from "./Components/Admin/AdminProfile";
import NotFound from "./Components/NotFound";
//import TestFiles from "../TestFiles";
import LoginRegister from "./Components/LoginRegister/LoginRegister";
import WelcomePage from "./Components/WelcomePage/WelcomePage";
import RequireUser from "./Components/lib/RequireUser";
import AdminInformation from "./Components/Admin/AdminInformation";
import ExperimentProjectSelect from "./Components/Experiments/ExperimentProjectSelect";
import MyLabSelect from "./Components/MyLab/MyLabSelect";
import MyLabProjects from "./Components/MyLab/MyLabProjects";
import MyLabSubgroups from "./Components/MyLab/MyLabSubgroups";
import UserExperiment from "./Components/Experiments/UserExperiment";
import { title } from "process";
import AdminGroupSelect from "./Components/Admin/AdminGroupSelect";
import ConnectionSelect from "./Components/Connections/ConnectionSelect";
import AddConnectionsPre from "./Components/Connections/AddConnectionsPre";
import FromMeRequestsPre from "./Components/Connections/FromMeRequestsPre";
import ToMeRequestsPre from "./Components/Connections/ToMeRequestsPre";
import MyConnectionsPre from "./Components/Connections/MyConnectionsPre";
import ProjectSelect from "./Components/Projects/ProjectSelect";
import SubgroupSelect from "./Components/Subgroups/SubgroupSelect";
import AllGroups from "./Components/Groups/AllGroups";
import SharedDataExperiment from "./Components/SharedData/SharedDataExperiment";
import SharedDataProjectSelect from "./Components/SharedData/SharedDataProjectSelect";
import RequireAuth from "../src/Components/lib/RequireAuth";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginRegister />} />

      <Route path="WelcomePage" element={<WelcomePage />} />

      <Route
        path="WelcomePage"
        element={
          <RequireAuth>
            <WelcomePage />
          </RequireAuth>
        }
      />

      <Route
        path="ExperimentProjectSelect"
        element={<ExperimentProjectSelect />}
      />
      <Route
        path="AdminGroupSelect"
        element={
          <RequireAuth>
            <AdminGroupSelect />
          </RequireAuth>
        }
      />
      <Route
        path="MyLabSelect"
        element={
          <RequireAuth>
            <MyLabSelect />
          </RequireAuth>
        }
      />
      <Route
        path="ConnectionSelect"
        element={
          <RequireAuth>
            <ConnectionSelect />
          </RequireAuth>
        }
      />
      <Route
        path="AddConnectionsPre"
        element={
          <RequireAuth>
            <AddConnectionsPre />
          </RequireAuth>
        }
      />
      <Route
        path="MyConnectionsPre"
        element={
          <RequireAuth>
            <MyConnectionsPre />
          </RequireAuth>
        }
      />
      <Route
        path="FromMeRequestsPre"
        element={
          <RequireAuth>
            <FromMeRequestsPre />
          </RequireAuth>
        }
      />
      <Route
        path="ToMeRequestsPre"
        element={
          <RequireAuth>
            <ToMeRequestsPre />
          </RequireAuth>
        }
      />
      <Route
        path="MyLabProjects"
        element={
          <RequireAuth>
            <MyLabProjects />
          </RequireAuth>
        }
      />
      <Route
        path="MyLabSubgroups"
        element={
          <RequireAuth>
            <MyLabSubgroups />
          </RequireAuth>
        }
      />
      <Route
        path="ProjectSelect"
        element={
          <RequireAuth>
            <ProjectSelect />
          </RequireAuth>
        }
      />
      <Route
        path="SubgroupSelect"
        element={
          <RequireAuth>
            <SubgroupSelect />
          </RequireAuth>
        }
      />
      <Route
        path="AdminInformation"
        element={
          <RequireAuth>
            <AdminInformation />
          </RequireAuth>
        }
      />
      <Route
        path="UserProfile"
        element={
          <RequireAuth>
            <UserProfile />
          </RequireAuth>
        }
      />
      <Route
        path="AIToolsPre"
        element={
          <RequireAuth>
            <AIToolsPre />
          </RequireAuth>
        }
      />
      <Route
        path="UserExperiment"
        element={
          <RequireAuth>
            <UserExperiment />
          </RequireAuth>
        }
      />
      <Route
        path="AllGroups"
        element={
          <RequireAuth>
            <AllGroups />
          </RequireAuth>
        }
      />
      <Route
        path="SharedDataExperiment"
        element={
          <RequireAuth>
            <SharedDataExperiment />
          </RequireAuth>
        }
      />
      <Route
        path="SharedDataProjectSelect"
        element={
          <RequireAuth>
            <SharedDataProjectSelect />
          </RequireAuth>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;

// <Route path="UserExperiment" element={<UserExperiment title={""} />} />
//      <Route path="UserExperiment" element={<UserExperiment />} />
